import { SOURCE_LANGUAGES, TARGET_LANGUAGES } from '@ellie/shared';
import type { CoverData, SourceLanguageCode, TargetLanguageCode } from '@ellie/shared';

interface CoverPageProps {
  coverData: CoverData;
  nativeLanguage: SourceLanguageCode;
  targetLanguage: TargetLanguageCode;
}

export function CoverPage({ coverData, nativeLanguage, targetLanguage }: CoverPageProps) {
  const native = SOURCE_LANGUAGES.find((l) => l.code === nativeLanguage);
  const target = TARGET_LANGUAGES.find((l) => l.code === targetLanguage);

  return (
    <div className="wb-page wb-cover" data-language={targetLanguage}>
      <img
        className="wb-cover-logo"
        src="https://cpewdtavfljubyxdshif.supabase.co/storage/v1/object/public/assets/Full%20Logo%20White%20with%20padding.png"
        alt="Ellie"
      />
      <h1>Your {coverData.targetLanguageName} workbook</h1>
      <div className="wb-language-badge">
        {native?.flag} {coverData.nativeLanguageName} <span className="wb-arrow">&rarr;</span>{' '}
        {target?.flag} {coverData.targetLanguageName}
      </div>
      <div className="wb-personalization">
        <div className="wb-for-label">Made for</div>
        <div className="wb-user-name">{coverData.displayName}</div>
      </div>
      <div className="wb-meta">
        <div className="wb-meta-item">
          <div className="wb-meta-label">Level</div>
          <div className="wb-meta-value">{coverData.level}</div>
        </div>
        <div className="wb-meta-item">
          <div className="wb-meta-label">Theme</div>
          <div className="wb-meta-value">{coverData.theme}</div>
        </div>
        <div className="wb-meta-item">
          <div className="wb-meta-label">Edition</div>
          <div className="wb-meta-value">
            {coverData.month} {coverData.year}
          </div>
        </div>
      </div>
      <div className="wb-edition">Language Enabler V.O.F. &middot; ellie-workbooks.com</div>
    </div>
  );
}
